import React, { useMemo } from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'

interface ICompaniesUsingServiceProps {
  country: string
}

const RU_LOGOS = [
  'images/amo.svg',
  'images/drobysh.svg',
  'images/art-lebedev.svg',
  'images/coffelike.svg',
  'images/getcourse.svg'
]

const UZ_LOGOS = [
  'images/chats-page/companies-using-logos/payze_logo.svg',
  'images/chats-page/companies-using-logos/union_logo.svg',
  'images/chats-page/companies-using-logos/easy_booking_logo.svg',
  'images/chats-page/companies-using-logos/media_group_logo.svg',
  'images/chats-page/companies-using-logos/hm_logo.svg',
  'images/chats-page/companies-using-logos/juba_logo.svg',
  'images/chats-page/companies-using-logos/upsoft_logo.svg',
  'images/chats-page/companies-using-logos/alfakom_logo.svg',
  'images/chats-page/companies-using-logos/inter_nation_logo.svg',
  'images/chats-page/companies-using-logos/proweb_logo.svg',
  'images/chats-page/companies-using-logos/greenpark_logo.svg',
  'images/chats-page/companies-using-logos/reverem_logo.svg',
  'images/chats-page/companies-using-logos/chimgan_hills_logo.svg',
  'images/chats-page/companies-using-logos/amirsoy_logo.svg',
  'images/chats-page/companies-using-logos/premium_auto_logo.svg',
  'images/chats-page/companies-using-logos/hyundai_logo.svg',
  'images/chats-page/companies-using-logos/cheary_logo.svg',
  'images/chats-page/companies-using-logos/faw_logo.svg',
  'images/chats-page/companies-using-logos/lada_logo.svg',
  'images/chats-page/companies-using-logos/evakor_logo.svg',
  'images/chats-page/companies-using-logos/mediva_logo.svg',
  'images/chats-page/companies-using-logos/evos_logo.svg',
  'images/chats-page/companies-using-logos/quadro_logo.svg',
  'images/chats-page/companies-using-logos/max_way_logo.svg',
  'images/chats-page/companies-using-logos/bosch_logo.svg',
  'images/chats-page/companies-using-logos/midea_logo.svg',
  'images/chats-page/companies-using-logos/ita_logo.svg',
  'images/chats-page/companies-using-logos/haval_logo.svg',
]

const CompaniesUsingService: React.FC<ICompaniesUsingServiceProps> = ({ country }) => {
  const logos = useMemo(() => {
    if (country === 'UZ') return UZ_LOGOS

    return RU_LOGOS
  }, [country])

  return (
    <Screen
      title={<span><StyledScreen.GreenText>4500+</StyledScreen.GreenText> компаний используют <br /> наш сервис каждый день</span>}
      bottomLine
      className='companies-using-service'
    >
      <div className='companies-using-service__container'>
        <div className='companies-using-service__logos-container'>
          <div className='companies-using-service__logos'>
            {
              logos.map((logo) => (
                <div className='companies-using-service__logo'>
                  <img src={`${process.env.PUBLIC_DIR}/${logo}`} alt={logo.split('/')[logo.split('/').length - 1]} />
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </Screen>
  )
}

export default CompaniesUsingService